module.exports = __webpack_public_path__ + "static/media/8.9b10fb65.jpg";